import NavBar from "components/NavBar";

export default function Layout(props: any): any {
  return (
    <div>
      <NavBar {...{ hotel: props, ...props }} />
      {props.children}
    </div>
  );
}
